module.exports = __webpack_public_path__ + "img/service.81754fb4.png";